
import * as navigationModels from '../models/navigationModels';


export function getNavigation(constant){
    let navigation = navigationModels.NAVIGATION_TYPES.filter(navigation => navigation.constant == constant);
    if (navigation) return navigation[0]; //since filter returns an array, have to grab the first.
    return null;
}

export function getPageNavigation(constant,newPageTitle,paramId){
    return new Promise((resolve, reject) => {

        const navigation = getNavigation(constant);
        let navObject = {};
        if(typeof newPageTitle !== 'undefined'){
            navObject = Object.assign({}, navigation,{
                pageTitle: newPageTitle
            });
        }else{
            navObject = Object.assign({}, navigation);
        }

        if(typeof paramId !== 'undefined'){

            navObject = Object.assign({}, navObject,{
                paramId: paramId.toString()
            });

            for(let i = 0; i < navObject.secondaryNav.length; i++){
                let nav = Object.assign({}, navObject.secondaryNav[i],{
                    path: navObject.secondaryNav[i].path + '/' + paramId
                });
            }
        }

        resolve(navObject);

    });
}





/** WEBPACK FOOTER **
 ** ./src/helpers/navigationHelper.js
 **/